export default __webpack_public_path__ + "static/media/logo_4.d04ac1fb.png";